module.exports = __webpack_public_path__ + "static/hero-house-1200w-21c5e673d9a65c6220aaaf7f18635db7.jpg";